/* Hero Section */
.hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fffdf7;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  overflow: hidden;
}

.hero.hideRadius {
  border-radius: 0;
}
.heroImage {
  width: 100%;
  height: auto;
  max-height: 100vh;
  object-fit: cover;
  object-position: 50% 85%;
  opacity: 0.7;
  position: relative;
  image-orientation: none;
}

.desktop {
  display: block;
}
.mobile {
  display: none;
}

@media (max-width: 768px) {
  .hero {
    flex-direction: column;
  }

  .heroImage {
    height: 70vh;
    opacity: 0.65;
  }

  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}

@media (max-width: 480px) {
  .heroContent {
    padding: 2rem;
  }
}
